import styled from 'styled-components'
import { BP } from 'resources/constants'
import { heading3 } from 'app/livbrite/resources/theme/css'

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${props => props.theme.palette.general.light};

  @media (max-width: ${BP.xs.max}) {
    flex-direction: column;
    margin-bottom: 15px;
    text-align: center;
  }

  p {
    margin-left: 5%;
    flex: 1;
    font-size: 18px;

    @media (max-width: ${BP.xs.max}) {
      margin-left: 0;
    }
  }
`

export const ResultItem = styled.div`
  padding: 20px;
  background: ${props => props.theme.palette.general.light};
  border-radius: 7px;
  box-shadow: 0 2px 8px 4px rgba(68, 68, 68, 0.5);
  margin-bottom: 12px;

  h3 {
    ${heading3}
  }

  p,
  button {
    font-size: 18px;
  }

  .actions {
    justify-content: flex-end;

    > button {
      margin: 10px 0 10px 10px;

      &.products {
        background: ${props => props.theme.palette.primary.beta};
      }
    }
  }
`
